import type { VariantProps } from "class-variance-authority";
import { cva } from "class-variance-authority";

export const textInputBase = cva([
  "block w-full rounded-sm border-0 outline-hidden disabled:cursor-not-allowed disabled:opacity-50",
], {
  variants: {
    variant: {
      primary: "bg-white ring-1 ring-slate-300 ring-inset placeholder:text-slate-400 focus:bg-white hover:enabled:ring-slate-400 focus:enabled:ring-indigo-600",
      "primary-box": "bg-transparent ring-1 ring-slate-300 ring-inset placeholder:text-slate-400 focus-within:bg-white focus-within:ring-indigo-600 hover:ring-slate-400 hover:focus-within:ring-indigo-600",
      secondary: "bg-white ring-1 ring-slate-300 ring-inset placeholder:text-slate-400 focus:outline-hidden",
    },
    size: {
      medium: "px-3 py-1 sm:py-1.5",
      small: "px-3 py-1 text-xs placeholder:text-xs sm:py-1.5",
      auto: "",
    },
  },
  defaultVariants: {
    variant: "primary",
    size: "medium",
  },
});

export type TextInputBaseProps = VariantProps<typeof textInputBase>;
